import { computed } from 'vue';
import { orderStatusGreaterOrEqual } from '@/helpers/order-helpers';
import { useOrderStore } from '@/stores/order';
import { useActiveUserStore } from '@/stores/user';

export function useFilesManagement() {
  const userStore = useActiveUserStore();
  const orderStore = useOrderStore();

  const hasFilesManagement = computed(() => {
    if (userStore.isCustomer) {
      return orderStatusGreaterOrEqual(
        orderStore.currentOrder,
        'quote_request'
      );
    }

    return ['Admin', 'Maker'].includes(userStore.activeSessionType);
  });

  // Positions and the files-management tab are either or
  const isPositionsOrder = computed(
    () => orderStore.currentOrder.isPositions ?? false
  );

  return { hasFilesManagement, isPositionsOrder };
}
